import { Inject, Injectable } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService {

    constructor(
        @Inject(PLATFORM_ID)
        private plId: Object,
        @Inject('LOCALSTORAGE')
        private lS: any

    ) { }

    getItem(key: string) {
        if (isPlatformBrowser(this.plId)) {
            if (this.lS.getItem(key)) {
                return this.lS.getItem(key)
            }else{
            return null
            }
        }
    }

    setItem(key: string, val: any): void {
        typeof val === 'number' ? val = val + '' : null
        if (isPlatformBrowser(this.plId)) {
            this.lS.setItem(key, val)
        }
    }

    removeItem(key:string){
        if (isPlatformBrowser(this.plId)) {
            this.lS.removeItem(key)
        }
    }
}
